import debug from 'debug';
import { terminal, UserAgentInfo } from 'constant';
import {
  commonApi,
  companyUUID,
  getQueryVariable,
  getShopifyUserId,
} from '@/service/api';
import { formMonitorSlsLog } from '@/service/formMonitorSlsLog';

const log = debug('cartsee:formEventV2');

/**
 * 通用参数
 */
export interface CommonParams {
  /**
   * 公司uuid
   */
  companyUUID: string;

  /**
   * 用户唯一id
   */
  shopifyUserId: string;

  /**
   * 终端
   */
  terminal: string;

  /**
   * 分辨率宽度
   */
  scrWid: number;

  /**
   * 分辨率高度
   */
  scrHei: number;

  /**
   * 操作系统版本
   */
  osVersion: string;

  /**
   * 浏览器品牌
   */
  browserBrand: string;

  /**
   * 浏览器版本
   */
  browserVersion: string;

  /**
   * 国家
   */
  country: string;

  /**
   * hostname
   */
  hostname: string;

  /**
   * utmMedium
   */
  utmMedium: string;

  /**
   * utmCampaign
   */
  utmCampaign: string;

  /**
   * pathname
   */
  pathname: string;

  /**
   * 前端时间戳
   */
  cliTimestamp: number;
}

/**
 * 自定义参数
 */
export interface CustomParams {
  /**
   * 事件名称
   */
  event: string;

  /**
   * 事件类型
   */
  eventType: string;

  /**
   * 弹窗id
   */
  formId: string;

  /**
   * 弹窗名称
   */
  formName: string;

  /**
   * 触发类型
   */
  triggerEventType: number;

  /**
   * 步骤
   */
  step: number;

  /**
   * 输入类型
   */
  inputType: string;

  /**
   * 完整url
   * @since 09-25
   */
  url: string;

  /**
   * navigator.userAgent
   */
  userAgent: string;

  /**
   * 标记，可扩展使用
   */
  remark: string;

  /**
   * 像素
   */
  pixel: string | number;

  /**
   * 请求结果
   */
  result: string;

  /**
   * 加载时长
   */
  loadTime: string | number;

  /**
   * code码
   */
  code: string;

  /**
   * 收集email
   */
  email: string;

  /**
   * 收集电话
   */
  phone: string;

  /**
   * 弹窗脚本加载开始
   */
  requestStart: string;

  /**
   * stream弹窗脚本加载开始
   */
  requestStart1: string;

  /**
   * 百分比
   */
  percentage: number;

  /**
   * 关闭方式
   */
  closeType: string;

  /**
   * stream正在展现弹窗
   */
  process: string;

  /**
   * stream正在展现弹窗
   */
  rendered: string;

  /**
   * stream已收集字段
   */
  collected: string;

  /**
   * 展示来源
   */
  showFrom: string;

  /**
   * 模板id
   */
  templateId: number;

  /**
   * 退出挽留触发方式
   */
  leaveTriggerType: string;

  /**
   * 弹窗名称
   */
  name: string;

  /**
   * 时间间隔
   */
  duration: number;
}

export type FormEventV2Params = CommonParams & Partial<CustomParams>;

export const formEventV2 = (params: Partial<CustomParams>) => {
  log(
    '%s',
    Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join(' '),
  );
  const utmMedium = getQueryVariable('utm_medium');
  const commonParams = {
    companyUUID,
    shopifyUserId: getShopifyUserId(),
    cliTimestamp: Date.now(),
    terminal: terminal ? 'pc' : 'mobile',
    scrWid: window.innerWidth,
    scrHei: window.innerHeight,
    osVersion: UserAgentInfo().osVersion,
    browserBrand: UserAgentInfo().browserBrand,
    browserVersion: UserAgentInfo().browserVersion,
    country: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hostname: window.location.hostname,
    utmMedium:
      utmMedium === 'Email' ? '邮箱' : utmMedium === 'Sms' ? '短信' : '自然',
    utmCampaign: getQueryVariable('utm_campaign') ?? '',
    pathname: window.location.pathname,
  };

  // 统计1812弹窗关闭次数
  if (params.event === 'popup_close_popup' && companyUUID === 'm5cahhz3') {
    formMonitorSlsLog({
      type: 'popup_close_popup',
      triggerEventType: params.triggerEventType,
      formId: params.formId,
      formName: params.formName,
      step: params.step,
      templateId: params.templateId,
      closeType: params.closeType,
      remark: params.remark,
      agent: navigator.userAgent,
    });
  }

  return commonApi({ ...commonParams, ...params }, 'form/formEventV2');
};
